import { Component } from '@angular/core';

import { DialogBase, DialogCloseReason } from '../../dialogs/base-dialog';
import { IImageFile } from '../../interfaces/files.interface';
import { FileModel } from '../../typescript-angular-client/model/fileModel';
import { IChangedFiles } from '../manager-content/file-manager-dialog-content.component';
import {
    IImageManagerDialogConfig, TImageManagerDialogCancelEvent, TImageManagerDialogOKEvent
} from './image-manager-dialog.model';

@Component({
  selector: 'image-manager-dialog',
  viewProviders: [],
  templateUrl: './image-manager-dialog.html',
})
export class ImageManagerDialogComponent extends DialogBase {
  private selectedFile: FileModel;
  private changedFiles: IChangedFiles;
  public dialogType = FileModel.FileTypeEnum.IMAGES;
  public maxFileSize = Math.pow(1024, 2) * 2;
  public enableImageEditing = true;
  public customTitleText: string;
  public showExportButton: boolean = true;

  constructor() {
    super();
  }

  public onSelectedFileChanged = (newlySelectedFile: FileModel): void => {
    this.selectedFile = newlySelectedFile;
  };

  public onChangedFilesUpdated = (changedFiles: IChangedFiles): void => {
    this.changedFiles = changedFiles;
  };

  public onCancel = (): void => {
    const cancelEvent: TImageManagerDialogCancelEvent = {
      reason: DialogCloseReason.CANCEL,
      data: { changedFiles: this.changedFiles },
    };
    super.close(cancelEvent);
  };

  public initDialog = (): void => {
    const dialogConfig = this.extraData as IImageManagerDialogConfig;
    if (dialogConfig !== undefined) {
      this.enableImageEditing = dialogConfig.enableImageEditing;

      if (dialogConfig.dialogType) {
        this.dialogType = dialogConfig.dialogType;
      }

      if (dialogConfig.customTitleText) {
        this.customTitleText = dialogConfig.customTitleText;
      }

      if (dialogConfig.maxFileSize) {
        this.maxFileSize = dialogConfig.maxFileSize;
      }

      if (dialogConfig.showExportButton !== undefined) {
        this.showExportButton = dialogConfig.showExportButton;
      }
    }
  };

  public onOk = (): void => {
    const selectedFile: IImageFile = {
      contentType: this.selectedFile.ContentType,
      id: this.selectedFile.Id,
      name: this.selectedFile.Name,
      parentFolderId: this.selectedFile.ParentFolderId,
      size: this.selectedFile.Size,
      src: this.selectedFile.Link,
      width: this.selectedFile.Width,
      height: this.selectedFile.Height,
      uploadDate: this.selectedFile.CreatedOn.toString(),
    };
    const closeOkEvent: TImageManagerDialogOKEvent = {
      reason: DialogCloseReason.OK,
      data: { changedFiles: this.changedFiles, selectedFile },
    };
    super.close(closeOkEvent);
  };
}
